import { defineStore } from 'pinia';
import translateService from '@/services/translate';
import { setI18nTranslate } from '@/plugins/i18n';

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    localeList: {
      loading: true,
      params: {},
      instance: [],
    },
    localeModel: {
      loading: false,
      params: {},
      instance: {},
    },
  }),

  getters: {
    selectedLanguage(state) {
      return state.localeModel.instance;
    },

    languagesList(state) {
      return state.localeList.instance;
    },

    languagesListLoading(state) {
      return state.localeList.loading;
    },
  },

  actions: {
    setLanguagesList(languagesList) {
      this.localeList.instance = languagesList;
    },

    setSelectedLanguage(language) {
      this.localeModel.instance = language;
    },

    listLoaded() {
      this.localeList.loading = false;
    },

    listLoading() {
      this.localeList.loading = true;
    },

    async selectLanguage(
      language = {
        title: 'EN',
        code: 'en',
      }
    ) {
      this.setSelectedLanguage(language);
      translateService.setDefaultLanguage(language?.code);

      try {
        const translations = await translateService.getTranslations({ languageId: language?.id });
        setI18nTranslate(translateService.translationsArrayToObject(translations), language?.code);
        // @todo добавить загрузку языка на бэк, если пользователь авторизован
      } catch {
        // @todo добавить обработку ошибок
      }
      // vee-validate v4: validation messages use i18n.t() in defineRule — no localeChanged()
    },

    async fetchLanguagesList() {
      this.listLoading();

      try {
        const languagesList = await translateService.getLanguages();
        const languages = languagesList.length
          ? languagesList
          : [
              {
                title: 'EN',
                code: 'en',
              },
            ];

        this.setLanguagesList(languages);

        const defaultLanguageCode = translateService.getDefaultLanguage();

        const defaultLanguage = languages.find(
          language => language.code.toLowerCase() === defaultLanguageCode.toLowerCase()
        );

        if (defaultLanguage) {
          await this.selectLanguage(defaultLanguage);
          return;
        }

        await this.selectLanguage(languages[0]);
        translateService.setDefaultLanguage(languages[0]?.code || 'en');
      } catch (err) {
        // @todo добавить обработку ошибок
      } finally {
        this.listLoaded();
      }
    },
  },
});
